import { render, staticRenderFns } from "./tabTradeDetail.vue?vue&type=template&id=887982cc&scoped=true&"
import script from "./tabTradeDetail.vue?vue&type=script&lang=js&"
export * from "./tabTradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./tabTradeDetail.vue?vue&type=style&index=0&id=887982cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887982cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('887982cc')) {
      api.createRecord('887982cc', component.options)
    } else {
      api.reload('887982cc', component.options)
    }
    module.hot.accept("./tabTradeDetail.vue?vue&type=template&id=887982cc&scoped=true&", function () {
      api.rerender('887982cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabTradeDetail.vue"
export default component.exports